import { defineSlotRecipe } from '@chakra-ui/react';

export const cssTooltipSlotRecipe = defineSlotRecipe({
    className: 'css-tooltip',
    slots: ['root', 'content'],
    base: {
        root: {
            position: 'relative',
            '&:hover .tooltip-content': {
                opacity: 1,
                visibility: 'visible',
            },
        },
        content: {
            '--tooltip-bg-color': '{colors.gray.950}',
            '--tooltip-fg-color': '{colors.white}',
            opacity: 0,
            visibility: 'hidden',
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            mb: 2,
            bg: 'var(--tooltip-bg-color)',
            color: 'var(--tooltip-fg-color)',
            p: 2,
            borderRadius: 'sm',
            fontSize: 'xs',
            lineHeight: '1.2',
            w: 'auto',
            maxW: '240px',
            minW: '190px',
            zIndex: 'tooltip',
            pointerEvents: 'none',
            transition: 'all 0.2s ease-in-out',

            _after: {
                content: '""',
                position: 'absolute',
                top: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                border: '5px solid transparent',
                borderTopColor: 'var(--tooltip-bg-color)',
            },
        },
    },
});
